import { PALETA_ATENDENTES, type AtendenteDTO } from '@viniko/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { useToast } from '../../componentes/ui';
import { patch } from '../../lib/api';
import { chaves } from '../../lib/consultas';
import { useCorAtendente } from '../../lib/tema';

export function MeuPerfil({ eu }: { eu: AtendenteDTO }) {
  const qc = useQueryClient();
  const toast = useToast();
  const cor = useCorAtendente(eu.cor);
  const [erro, setErro] = useState<string | null>(null);

  async function salvar(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = e.currentTarget;
    const d = Object.fromEntries(new FormData(f)) as Record<string, string>;
    if (d.novaSenha && d.novaSenha !== d.confirmar)
      return setErro('A confirmação não bate com a nova senha.');
    setErro(null);
    try {
      const a = await patch<AtendenteDTO>('/api/eu', {
        nomeExibicao: d.nomeExibicao,
        ...(d.novaSenha ? { senhaAtual: d.senhaAtual, novaSenha: d.novaSenha } : {}),
      });
      qc.setQueryData(chaves.eu, a);
      qc.invalidateQueries({ queryKey: chaves.atendentes });
      f.reset();
      toast('Perfil salvo');
    } catch (err) {
      setErro((err as Error).message);
    }
  }

  return (
    <form className="config-cartao" onSubmit={salvar}>
      <header>
        <h2>Meu perfil</h2>
        <p>O nome de exibição vai na frente das suas mensagens no WhatsApp do cliente.</p>
      </header>
      <div className="previa-assinatura" style={{ background: cor.fundo }}>
        <b style={{ color: cor.texto }}>*{eu.nomeExibicao}:*</b>
        <span>Seu orçamento ficou pronto, segue o PDF.</span>
        <small>Sua cor: {PALETA_ATENDENTES[eu.cor].nome} (definida pelo admin)</small>
      </div>
      <label className="campo">
        <span>Nome de exibição</span>
        <input
          id="perfil-nome"
          name="nomeExibicao"
          className="input"
          defaultValue={eu.nomeExibicao}
          maxLength={24}
          required
        />
      </label>
      <fieldset className="grupo">
        <legend>Trocar senha</legend>
        <label className="campo">
          <span>Senha atual</span>
          <input
            id="perfil-senha-atual"
            name="senhaAtual"
            type="password"
            className="input"
            autoComplete="current-password"
          />
        </label>
        <div className="duas">
          <label className="campo">
            <span>Nova senha</span>
            <input
              id="perfil-nova"
              name="novaSenha"
              type="password"
              className="input"
              minLength={8}
              autoComplete="new-password"
            />
          </label>
          <label className="campo">
            <span>Confirmar</span>
            <input
              id="perfil-confirmar"
              name="confirmar"
              type="password"
              className="input"
              autoComplete="new-password"
            />
          </label>
        </div>
      </fieldset>
      {erro && <div className="erro-form">{erro}</div>}
      <div>
        <button className="btn primario">Salvar</button>
      </div>
    </form>
  );
}
